import { render, staticRenderFns } from "./DashboardLayoutDataAdmin.vue?vue&type=template&id=2fd97c14&"
import script from "./DashboardLayoutDataAdmin.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutDataAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutDataAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports